{
  "enum": {
    "IxcInventoryV1BooksOrderKind": {
      "MIXED_CAPACITY": "Mixed Capacity",
      "PRINCIPAL": "Principal",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1BooksOrderOutcome": {
      "NOT_FILLED": "Not Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "SUCCESS": "Success",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1BooksOrderStatus": {
      "AWAITING_FIRM_FILL": "Awaiting Firm Fill",
      "AWAITING_INVENTORY": "Awaiting Inventory",
      "AWAITING_QUOTE": "Awaiting Quote",
      "CANCELED": "Canceled",
      "CANCELING": "Canceling",
      "EXECUTED": "Executed",
      "NOT_FILLED": "Not Filled",
      "REQUESTED": "Requested",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1FirmOrderCapacity": {
      "PRINCIPAL": "Principal",
      "RISKLESS_PRINCIPAL": "Riskless Principal",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1FirmOrderKind": {
      "REPLENISH": "Replenish",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1FirmOrderOutcomeOutcome": {
      "FULLY_FILLED": "Fully Filled",
      "NOT_FILLED": "Not Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1FirmOrderStatus": {
      "ACTIVE": "Active",
      "ALLOCATED": "Allocated",
      "ALLOCATION_WAIT": "Allocation Wait",
      "CANCELED": "Canceled",
      "CANCELLING": "Cancelling",
      "DONE": "Done",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1OrderInstructionTimeInForce": {
      "DAY": "Day",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1PriceSource": {
      "AVERAGE": "Average",
      "QUOTE": "Quote",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1SecurityDayStatus": {
      "BOOKS_CLOSED": "Books Closed",
      "PENDING": "Pending",
      "SETTLED": "Settled",
      "TRADING_CLOSED": "Trading Closed",
      "TRADING_OPEN": "Trading Open",
      "UC_BOOKS_CLOSED": "Uc Books Closed",
      "UC_SETTLED": "Uc Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcInventoryV1TradingDayStatus": {
      "CLOSED": "Closed",
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcInventoryV1BooksOrderQueryServiceBooksOrderListFilterableFields": {
      "assetId": "Asset",
      "booksOrderId": "Books Order",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        },
        "spec": {
          "priceSource": "Price Source",
          "side": "Side"
        }
      },
      "orderId": "Order",
      "status": "Status"
    },
    "IxcInventoryV1FirmOrderQueryServiceFirmOrderListFilterableFields": {
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "firmOrderId": "Firm Order",
      "status": "Status"
    },
    "IxcInventoryV1SecurityDayQueryServiceSecurityDayListFilterableFields": {
      "assetId": "Asset ID",
      "data": {
        "asset": {
          "assetId": "Data Asset Asset ID",
          "data": {
            "category": "Data Asset Data Category",
            "type": {
              "!type": "Data Asset Data Type Type",
              "equity": {
                "controls": {
                  "canBuy": "Data Asset Data Type Equity Controls Can Buy",
                  "canEnterFractions": "Data Asset Data Type Equity Controls Can Enter Fractions",
                  "canSell": "Data Asset Data Type Equity Controls Can Sell"
                },
                "cusip": "Data Asset Data Type Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Data Asset Data Type Money Market Classification",
                "controls": {
                  "canBuy": "Data Asset Data Type Money Market Controls Can Buy",
                  "canEnterFractions": "Data Asset Data Type Money Market Controls Can Enter Fractions",
                  "canSell": "Data Asset Data Type Money Market Controls Can Sell"
                },
                "cusip": "Data Asset Data Type Money Market CUSIP",
                "navType": "Data Asset Data Type Money Market NAV Type"
              }
            }
          },
          "status": "Data Asset Status"
        }
      },
      "settleDate": "Settle Date",
      "status": "Status",
      "tradeDate": "Trade Date"
    },
    "IxcInventoryV1TradingDayQueryServiceTradingDayListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcInventoryV1BooksOrderAmount": {
      "notional": "Notional",
      "quantity": "Quantity"
    },
    "IxcInventoryV1BooksOrderEventType": {
      "cancel": "Cancel",
      "canceled": "Canceled",
      "dequeued": "Dequeued",
      "executed": "Executed",
      "firmFilled": "Firm Filled",
      "firmNotFilled": "Firm Not Filled",
      "mixedCapacityExecuted": "Mixed Capacity Executed",
      "mixedCapacityRequested": "Mixed Capacity Requested",
      "purePrincipalRequested": "Pure Principal Requested",
      "queued": "Queued",
      "quoteReceived": "Quote Received",
      "quoteRequested": "Quote Requested",
      "requested": "Requested"
    },
    "IxcInventoryV1FirmOrderEventType": {
      "allocated": "Allocated",
      "allocationExpected": "Allocation Expected",
      "allocationRequested": "Allocation Requested",
      "cancelRequested": "Cancel Requested",
      "done": "Done",
      "fill": "Fill",
      "rejected": "Rejected",
      "routeCanceled": "Route Canceled",
      "routeExternal": "Route External",
      "submitted": "Submitted"
    },
    "IxcInventoryV1SecurityDayEventType": {
      "closeBooks": "Close Books",
      "closeUnknownCost": "Close Unknown Cost",
      "closingFigures": "Closing Figures",
      "corporateActionAdjustment": "Adjustment",
      "corporateActionCalculated": "Calculated",
      "corporateActionTrigger": "Trigger",
      "initFirstDay": "Init First Day",
      "previousClose": "Previous Close",
      "settle": "Settle",
      "tradingDayClosed": "Trading Day Closed",
      "tradingDayOpen": "Trading Day Open"
    },
    "IxcInventoryV1SettleTradingDayTransactionTotals": {
      "full": "Full",
      "provisional": "Provisional"
    },
    "IxcInventoryV1TradingDayEventType": {
      "close": "Close",
      "closed": "Closed",
      "customerTradeEntered": "Customer Trade Entered",
      "inventoryTradeEntered": "Inventory Trade Entered",
      "open": "Open",
      "risklessTradeEntered": "Riskless Trade Entered"
    }
  },
  "searchEnum": {
    "IxcInventoryV1BooksOrderQueryServiceBooksOrderListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcInventoryV1FirmOrderQueryServiceFirmOrderListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcInventoryV1SecurityDayQueryServiceSecurityDayListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Data Asset Data Type Equity Name",
                "symbol": {
                  "base": "Data Asset Data Type Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Data Asset Data Type Money Market Name",
                "symbol": {
                  "base": "Data Asset Data Type Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcInventoryV1TradingDayQueryServiceTradingDayListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcInventoryV1BooksOrderQueryServiceBooksOrderListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcInventoryV1FirmOrderQueryServiceFirmOrderListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcInventoryV1SecurityDayQueryServiceSecurityDayListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Data Asset Metadata Created At",
            "updatedAt": "Data Asset Metadata Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxcInventoryV1TradingDayQueryServiceTradingDayListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}